import { render, staticRenderFns } from "./FooterSchuette.vue?vue&type=template&id=748bf7c2&scoped=true&"
import script from "./FooterSchuette.vue?vue&type=script&lang=js&"
export * from "./FooterSchuette.vue?vue&type=script&lang=js&"
import style0 from "./FooterSchuette.vue?vue&type=style&index=0&id=748bf7c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bf7c2",
  null
  
)

export default component.exports